import { Component } from '@angular/core';
import { UploadPhotoModalComponent } from '@components/base/client/modals/upload-photo-modal/upload-photo-modal';

@Component({
	selector: 'upload-photo-modal',
	template: require('./upload-photo-modal.html'),
	styles: [require('./upload-photo-modal.scss')]
})
export class UploadPhotoModalWebComponent extends UploadPhotoModalComponent {
	hideModal(): void {
		$('#uploadPhotoModal').modal('hide');
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/client/modals/upload-photo-modal/upload-photo-modal.ts